import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {User} from "../../../shared/interface/user";
import {takeUntil, tap} from "rxjs/operators";
import {UserService} from "../../../shared/services/user.service";
import {CrmUserPermissions} from "../../../shared/interface/crm-user-permissions";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {MatPaginator} from "@angular/material/paginator";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {CrmUserPermissionsAddComponent} from "../crm-user-permissions-add/crm-user-permissions-add.component";

@Component({
  selector: 'app-crm-user-permissions-list',
  templateUrl: './crm-user-permissions-list.component.html',
  styleUrls: ['./crm-user-permissions-list.component.scss']
})
export class CrmUserPermissionsListComponent implements OnInit, OnDestroy {
  @Input() user: Observable<User>;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  userObject?: User;
  users360Permissions: CrmUserPermissions[] = [];
  displayedColumns: string[] = ['partner',  'ofwca', 'createdBy', 'createdAt',  'updateAt'];
  totalData = 0;
  initialFilters: any;
  userPermissions: ReplaySubject<UserPermissions>;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private userService: UserService,
    private auth: AuthService,
    public dialog: MatDialog,
  ) {
    this.userPermissions = this.auth.getUserPermissions();
    this.userService.getCrmUserPermissionsListSubject()
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<CrmUserPermissions>) => {
          this.users360Permissions = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
  }

  ngOnInit(): void {
    this.user
      .pipe(takeUntil(this.destroyed$))
      .subscribe((user: User) => {
        this.userObject = user;
        this.loadListData();
      });
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    if (null !== this.userObject) {
      filters.user = this.userObject.uuid;
    }

    return filters;
  }

  loadListData(): void {
    this.userService.loadPermissions306List(0, 10, this.buildFilters());
  }

  addUserPermissions(): void{
    const dialogRef = this.dialog.open(CrmUserPermissionsAddComponent, {
      width: '800px',
      data: {user: this.userObject},
      maxHeight: '1000px',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadListData();
    });
  }
}
